import Layout from 'components/Layout'
import Items from 'components/RevenueCenters/Form/Drawers/Items'

const ItemsDrawer = () => {
  return <Layout mainContent={<Items />} />
}

export default ItemsDrawer
